import type { Config } from "@jti/fe-common";
import { getConfig } from "@jti/fe-common";

import { getIsEvo, getUser } from "../../../utils";

import type { CasAuthApiContract } from "./CasAuthApi.types";
import { CasAuthApiEvo } from "./CasAuthApiEvo";
import { CasAuthApiLegacy } from "./CasAuthApiLegacy";

export class CasAuthApi {
  readonly name = "CasAuthApi";

  /* 
    additionalConfig is a workaround to exclude possibility of 
    hydration race condition when the meta tags injected but
    we still get the {} config 
  */
  static init(additionalConfig: Config | null = null): CasAuthApiContract {
    const config = additionalConfig || getConfig();
    const user = getUser();
    if (config.USE_EVO_ONLY) {
      return new CasAuthApiEvo(config.EVO_DOMAIN, config.EVO_TENANT, config["X-RECAPTCHA-ID"], user.ciam_token);
    }
    if (getIsEvo(config.CAS_URL)) {
      return new CasAuthApiEvo(
        config.CAS_URL,
        config.CAS_X_DES_AK_TENANT_TOKEN,
        config["X-RECAPTCHA-ID"],
        user.ciam_token
      );
    }
    return new CasAuthApiLegacy(config.CAS_URL, config.CAS_X_DES_AK_TENANT_TOKEN, user.ciam_token);
  }
}
